import { Card, Image, Typography } from "antd";
import { useNavigate, useSearchParams } from "react-router-dom";
import { SignUpForm } from "../../Components/AuthForms";
import { useAppContext } from "../../Context/AppContext/AppContext";
import PageMetadata from "../../Components/PageMetaData/PageMetaData";
import { getPageMetaData } from "../../Utils/meta-data";
import TransitionWrapper from "../../Components/TransitionWrapper";
import { getGradientStyle } from "../../Utils/generic-functions";
import AuthPageSection from "../../Components/AuthPageSection/AuthPageSection";
import AuthPageFooter from "../../Components/AuthPageFooter/AuthPageFooter";
import "./index.scss";

const Signup = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { organization } = useAppContext();
  const redirect_url = searchParams.get("redirect_url") || null;

  const handleSignInClick = () => {
    const signInUrl = redirect_url
      ? `/sign-in?redirect_url=${redirect_url}`
      : "/sign-in";
    navigate(signInUrl);
  };

  const handleSuccess = () => {
    // Auth state will update automatically via AuthContext
    // ProtectedLogin will handle navigation with redirect_url from query params
  };

  const meta = organization
    ? getPageMetaData("signup", { organization })
    : getPageMetaData("signup");

  const orgLogoUrl = organization?.logo
    ? `https://hiring-assistant-files.s3.ap-south-1.amazonaws.com/organization/${organization?._id}/${organization?.logo}`
    : "/images/qualifyme_light.png";

  const bg = getGradientStyle(organization?.theme?.primaryColor || "#F7A500");

  return (
    <>
      <PageMetadata title={meta.title} description={meta.description} />
      <TransitionWrapper transitionType="slide-up">
        <section className="signup-page">
          <div className="signup-page-content">
            <div className="left-section">
              <div className="signup-content">
                <Card
                  className="signup-card"
                  style={{ maxWidth: 400, width: "100%" }}
                  bordered={false}
                  title={
                    <section className="signup-card-title">
                      <Image
                        preview={false}
                        src={orgLogoUrl}
                        fallback={"/images/qualifyme_light.png"}
                        width="48px"
                        height="auto"
                      />
                      <Typography.Title style={{ margin: 0 }} level={4}>
                        Signup
                      </Typography.Title>
                    </section>
                  }
                >
                  <SignUpForm
                    onSuccess={handleSuccess}
                    onSignInClick={handleSignInClick}
                  />
                </Card>
                <AuthPageFooter type="signup" />
              </div>
            </div>
            <div className="right-section" style={bg}>
              <AuthPageSection type="signup" />
            </div>
          </div>
        </section>
      </TransitionWrapper>
    </>
  );
};

export default Signup;
